import React from "react";
import "./dashboardSkeleton.css";

const LoadingSkeleton = () => {
  return (
    <div className='sales-dashboard-skeleton'>
      {/* Header Section */}
      <div className='skeleton-header'>
        <div className='skeleton-title'></div>
        <div className='skeleton-date-filter'></div>
      </div>

      {/* Metrics Cards Row */}
      <div className='skeleton-metrics-row'>
        <div className='skeleton-metric-card'>
          <div className='skeleton-metric-icon'></div>
          <div className='skeleton-metric-content'>
            <div className='skeleton-metric-label'></div>
            <div className='skeleton-metric-value'></div>
            <div className='skeleton-metric-change'></div>
          </div>
        </div>

        <div className='skeleton-metric-card'>
          <div className='skeleton-metric-icon'></div>
          <div className='skeleton-metric-content'>
            <div className='skeleton-metric-label'></div>
            <div className='skeleton-metric-value'></div>
            <div className='skeleton-metric-change'></div>
          </div>
        </div>

        <div className='skeleton-metric-card'>
          <div className='skeleton-metric-icon'></div>
          <div className='skeleton-metric-content'>
            <div className='skeleton-metric-label'></div>
            <div className='skeleton-metric-value'></div>
            <div className='skeleton-metric-change'></div>
          </div>
        </div>

        <div className='skeleton-metric-card'>
          <div className='skeleton-metric-icon'></div>
          <div className='skeleton-metric-content'>
            <div className='skeleton-metric-label'></div>
            <div className='skeleton-metric-value'></div>
            <div className='skeleton-metric-change'></div>
          </div>
        </div>
      </div>

      {/* Main Content Area */}
      <div className='skeleton-main-content'>
        {/* Left Section - Charts */}
        <div className='skeleton-charts-section'>
          {/* Profit vs Expense Chart */}
          <div className='skeleton-chart-container'>
            <div className='skeleton-chart-header'>
              <div className='skeleton-chart-title'></div>
              <div className='skeleton-chart-legend'>
                <div className='skeleton-legend-item'></div>
                <div className='skeleton-legend-item'></div>
              </div>
            </div>
            <div className='skeleton-line-chart'>
              <div className='skeleton-chart-y-axis'>
                <div className='skeleton-axis-label'></div>
                <div className='skeleton-axis-label'></div>
                <div className='skeleton-axis-label'></div>
                <div className='skeleton-axis-label'></div>
                <div className='skeleton-axis-label'></div>
              </div>
              <div className='skeleton-chart-area'>
                <div className='skeleton-line-path'></div>
              </div>
            </div>
          </div>

          {/* Bottom Charts Row */}
          <div className='skeleton-bottom-charts'>
            <div className='skeleton-bar-chart-container'>
              <div className='skeleton-chart-title-small'></div>
              <div className='skeleton-bar-chart'>
                <div className='skeleton-bar'></div>
                <div className='skeleton-bar'></div>
                <div className='skeleton-bar'></div>
                <div className='skeleton-bar'></div>
                <div className='skeleton-bar'></div>
              </div>
            </div>

            <div className='skeleton-visitors-chart'>
              <div className='skeleton-chart-title-small'></div>
              <div className='skeleton-visitors-content'>
                <div className='skeleton-visitor-bar'></div>
                <div className='skeleton-visitor-number'></div>
              </div>
            </div>
          </div>
        </div>

        {/* Right Section - Side Panels */}
        <div className='skeleton-side-panels'>
          {/* Transactions Donut Chart */}
          <div className='skeleton-transactions-panel'>
            <div className='skeleton-panel-title'></div>
            <div className='skeleton-donut-chart'>
              <div className='skeleton-donut-ring'></div>
            </div>
            <div className='skeleton-donut-legend'>
              <div className='skeleton-donut-legend-item'></div>
              <div className='skeleton-donut-legend-item'></div>
            </div>
          </div>

          {/* Productivity Index */}
          <div className='skeleton-productivity-panel'>
            <div className='skeleton-panel-title'></div>
            <div className='skeleton-productivity-chart'>
              <div className='skeleton-gauge'></div>
              <div className='skeleton-gauge-value'></div>
            </div>
          </div>

          {/* New Customers Panel */}
          <div className='skeleton-customers-panel'>
            <div className='skeleton-panel-header'></div>
            <div className='skeleton-panel-content'></div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LoadingSkeleton;
